module.exports = __webpack_public_path__ + "img/index-t-slide2.b7a195a8.jpg";